import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./layouts/dashboard";
import DashboardPage from "./pages/AdminDashboard/Index";
import OrdersPage from "./pages/AdminDashboard/Orders";
import Product from "./pages/AdminDashboard/Product";
import Category from "./pages/AdminDashboard/Category";
import UserDashboard from "./pages/UserDashboard";
import Home from "./pages/AppPages/Home/Home";
import Login from "./pages/AppPages/Login/Login";
import Register from "./pages/AppPages/Register/Register";
import Sales from "./pages/AdminDashboard/Sales";
import Users from "./pages/AdminDashboard/Users";
import Profile from "./pages/AdminDashboard/Profile";
import Traffic from "./pages/AdminDashboard/Traffic";
import Shipping from "./pages/AdminDashboard/Shipping";
import Preferences from "./pages/AdminDashboard/Preferences";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      element: <App />,
      children: [
        {
          path: "/admin",
          element: <Layout />,

          children: [
            {
              path: "/admin/orders",
              element: <OrdersPage />,
            },
            {
              path: "/admin/products",
              element: <Product />,
            },
            {
              path: "/admin/category",
              element: <Category />,
            },
            {
              path: "/admin/dashboard",
              element: <DashboardPage />,
            },
            {
              path: "/admin/users",
              element: <Users />,
            },
            {
              path: "/admin/profile",
              element: <Profile />,
            },
            {
              path: "/admin/shipping",
              element: <Shipping />,
            },
            {
              path: "/admin/preferences",
              element: <Preferences />,
            },
            {
              path: "/admin/reports/sales",
              element: <Sales />,
            },
            {
              path: "/admin/reports/traffic",
              element: <Traffic />,
            },
          ],
        },
      ],
    },
    {
      element: <App />,
      children: [
        {
          path: "/user",
          element: <Layout />,

          children: [
            {
              path: "/user/orders",
              element: <OrdersPage />,
            },
            {
              path: "/user/dashboard",
              element: <UserDashboard />,
            },
          ],
        },
      ],
    },
  ]
  //{ basename: "/app" },
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
